export default function Concerns() {
  const concerns = [
    '内申点が足りず志望校を諦めかけている',
    '偏差値が半年間上がっていない',
    '夏からでも\n間に合うか\n不安',
    '何から勉強すればいいか分からない',
    '定期テストの点数が伸びない',
    '部活と勉強の両立ができない',
    '受験情報\nが分からず\n不安',
    '塾に通っているのに成績が上がらない',
    '志望校の\nレベルを\n下げるべきか悩んでいる',
    '自宅学習が続かない'
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-[#F5F5F7]">
      <div className="max-w-lg md:max-w-4xl lg:max-w-6xl mx-auto">
        {/* タイトル */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 text-[#1A2B4A] mb-3">
            <i className="ri-book-2-line text-xl"></i>
            <span className="text-sm font-medium">受験生の保護者様へ</span>
          </div>
          <h2 className="text-[32px] md:text-[40px] font-bold text-[#1A2B4A] leading-tight">
            こんなお悩み、<br className="md:hidden" />ありませんか？
          </h2>
        </div>

        {/* 悩みカードグリッド */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {concerns.map((concern, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-5 md:p-6 shadow-sm"
            >
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#FF6B35] text-lg mt-0.5 flex-shrink-0"></i>
                <p className="text-[#1A2B4A] text-[15px] leading-relaxed whitespace-pre-line">
                  {concern}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 共感メッセージ */}
        <div className="mt-8 md:mt-12 text-center">
          <p className="text-[#1A2B4A] text-base md:text-lg leading-relaxed">
            受験まで時間がない中、<br />
            <strong className="font-bold">どうすれば合格できるのか</strong>不安ですよね。
          </p>
        </div>
      </div>
    </section>
  );
}
